// import Thumbnail01mp4 from './thumbnail-1.mp4';
import Thumbnail02mp4 from './thumbnail-2.mp4';
import Thumbnail03mp4 from './thumbnail-3.mp4';
import Thumbnail04mp4 from './thumbnail-4.mp4';
import Thumbnail05mp4 from './thumbnail-5.mp4';
import Thumbnail06mp4 from './thumbnail-6.mp4';
import Thumbnail07mp4 from './thumbnail-7.mp4';
import Thumbnail08mp4 from './thumbnail-8.mp4';
import Thumbnail09mp4 from './thumbnail-9.mp4';
import Thumbnail10mp4 from './thumbnail-10.mp4';
import Thumbnail11mp4 from './thumbnail-11.mp4';
import Thumbnail12mp4 from './thumbnail-12.mp4';
import Thumbnail13mp4 from './thumbnail-13.mp4';
import Thumbnail14mp4 from './thumbnail-14.mp4';
import Thumbnail15mp4 from './thumbnail-15.mp4';

// import Thumbnail01webm from './thumbnail-1.webm';
import Thumbnail02webm from './thumbnail-2.webm';
import Thumbnail03webm from './thumbnail-3.webm';
import Thumbnail04webm from './thumbnail-4.webm';
import Thumbnail05webm from './thumbnail-5.webm';
import Thumbnail06webm from './thumbnail-6.webm';
import Thumbnail07webm from './thumbnail-7.webm';
import Thumbnail08webm from './thumbnail-8.webm';
import Thumbnail09webm from './thumbnail-9.webm';
import Thumbnail10webm from './thumbnail-10.webm';
import Thumbnail11webm from './thumbnail-11.webm';
import Thumbnail12webm from './thumbnail-12.webm';
import Thumbnail13webm from './thumbnail-13.webm';
import Thumbnail14webm from './thumbnail-14.webm';
import Thumbnail15webm from './thumbnail-15.webm';

// import Thumbnail16webm from './thumbnail-16.webm';
// import Thumbnail17webm from './thumbnail-17.webm';

export default [
    // { mp4: Thumbnail01mp4, webm: Thumbnail01webm },
    { mp4: Thumbnail02mp4, webm: Thumbnail02webm },
    { mp4: Thumbnail03mp4, webm: Thumbnail03webm },
    { mp4: Thumbnail04mp4, webm: Thumbnail04webm },
    { mp4: Thumbnail05mp4, webm: Thumbnail05webm },
    { mp4: Thumbnail06mp4, webm: Thumbnail06webm },
    { mp4: Thumbnail07mp4, webm: Thumbnail07webm },
    { mp4: Thumbnail08mp4, webm: Thumbnail08webm },
    { mp4: Thumbnail09mp4, webm: Thumbnail09webm },
    { mp4: Thumbnail10mp4, webm: Thumbnail10webm },
    { mp4: Thumbnail11mp4, webm: Thumbnail11webm },
    { mp4: Thumbnail12mp4, webm: Thumbnail12webm },
    { mp4: Thumbnail13mp4, webm: Thumbnail13webm },
    { mp4: Thumbnail14mp4, webm: Thumbnail14webm },
    { mp4: Thumbnail15mp4, webm: Thumbnail15webm },
];
